module.exports = __webpack_public_path__ + "static/img/icon-style-dropdown.ba550a03.png";